import { CareerPathway } from '@cpd-app/generated';
import { createAction, props } from '@ngrx/store';

export const getPathway = createAction(
  '[Pathway] Get Pathway',
  props<{ pathwayId: string }>()
);

export const getPathwaySuccess = createAction(
  '[Pathway] Get Pathway Success',
  props<{ pathway: CareerPathway }>()
);

export const getPathwayFailure = createAction(
  '[Pathway] Get Pathway Failure',
  props<{ error: any }>()
);

export const clearPathway = createAction('[Pathway] Clear Pathway');
